import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

function EventDetail() {
  const { eventId } = useParams();
  const navigate = useNavigate();
  const [event, setEvent] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchEvent = async () => {
      try {
        console.log('Fetching events from local file...');
        const response = await fetch('https://414ministry.org/upcomingevents.json');
        if (!response.ok) {
          throw new Error('Failed to load events');
        }
        const events = await response.json();
        const foundEvent = Array.isArray(events)
          ? events.find((e) => e.id === parseInt(eventId))
          : events.id === parseInt(eventId)
          ? events
          : null;
        if (!foundEvent) {
          throw new Error('Event not found');
        }
        console.log('Found event:', foundEvent);
        setEvent(foundEvent);
      } catch (err) {
        console.error('Error fetching event details:', err);
        setError('Failed to load event details: ' + err.message);
      }
    };

    fetchEvent();
  }, [eventId]);

  const parseEventDetails = (event) => {
    let date = 'Date TBD';
    let location = 'Location TBD';

    // Parse date from meta.event_date
    if (event?.meta?.event_date) {
      try {
        const year = event.meta.event_date.substring(0, 4);
        const month = event.meta.event_date.substring(4, 6);
        const day = event.meta.event_date.substring(6, 8);
        date = `${month}/${day}/${year}`;
      } catch (e) {
        console.warn('Invalid date format:', event.meta.event_date);
      }
    }

    // Parse location from content.rendered
    if (event?.content?.rendered) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(event.content.rendered, 'text/html');
      const paragraphs = doc.querySelectorAll('p');
      for (const p of paragraphs) {
        const html = p.innerHTML;
        if (html.includes('<strong>Location')) {
          const locationMatch = html.match(/<strong>Location:?\s*<\/strong>\s*([^<]+)(?:<br\s*\/?>|$)/i);
          if (locationMatch && locationMatch[1]) {
            location = locationMatch[1].trim();
            break;
          }
        }
      }
    }

    return { date, location };
  };

  if (error) {
    return (
      <div className="container">
        <div className="loading-container">
          <h2>Event Details</h2>
          <p>{error}</p>
        </div>
      </div>
    );
  }

  if (!event) {
    return (
      <div className="container">
        <div className="loading-container">
          <h2>Event Details</h2>
          <p>Loading...</p>
        </div>
      </div>
    );
  }

  const { date, location } = parseEventDetails(event);

  return (
    <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <div className="flex justify-between items-center mb-6">
        <button
          onClick={() => navigate('/')}
          className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 transition-colors duration-300"
        >
          Back to Home
          <svg className="ml-2 w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 19l-7-7 7-7" />
          </svg>
        </button>
      </div>
      <div className="text-center mb-12">
        <h2 className="text-3xl font-bold text-gray-900 sm:text-4xl">
          {event.yoast_head_json?.og_title?.replace(' - Calvary Baptist Church', '') || 'Untitled Event'}
        </h2>
      </div>
      <div className="flex flex-col items-center mb-6 space-y-2 sm:flex-row sm:space-y-0 sm:space-x-4 sm:justify-center">
        <h3 className="text-xl font-semibold text-gray-900">
          <span className="font-bold">Date:</span> {date}
        </h3>
        <h3 className="text-xl font-semibold text-gray-900">
          <span className="font-bold">Location:</span> {location}
        </h3>
      </div>
      <div className="prose prose-gray max-w-none text-gray-600 mb-6 text-center">
        <div
          dangerouslySetInnerHTML={{
            __html: event.content.rendered.replace(/<h[12]>.*<\/h[12]>/g, ''), // Remove h1 or h2 titles
          }}
        />
      </div>
    </div>
  );
}

export default EventDetail;